import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'zikatagov-badge',
  template: `
    <span class="badge" [ngClass]="'bg-' + color">
      <ng-content></ng-content>
    </span>
  `,
  standalone: true,
  imports: [CommonModule],
})
export class ZikataBadgeComponent {
  @Input() color = 'primary';
}
